import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class Column extends PureComponent {
  colsBuilder() {
    let cols = `${midas.column} `
    const keys = Object.keys(this.props)
    const filteredKeys = keys.filter(key => {
      return this.props[key]
    })

    filteredKeys.map(key => {
      cols += `${midas[key]} `
      return cols
    })

    return cols
  }

  render() {
    return (
      <div className={this.colsBuilder()}>
        {this.props.children && this.props.children}
      </div>
    )
  }
}

const cols = {}

for (let i = 0; i < 12; i++) {
  cols[`col${i + 1}`] = PropTypes.bool
  cols[`colMd${i + 1}`] = PropTypes.bool
  cols[`colSm${i + 1}`] = PropTypes.bool
}

Column.defaultProps = {
  children: null,
}

Column.propTypes = {
  children: PropTypes.any,
}
